import { useQuery } from "@tanstack/react-query";
import Repository from "./Repository";
import { Team, TeamDetails, TeamMembers, TeamType } from "./types/Teams";
const teamTypes = "/teamTypes";
const teams = "/teams";

export default {
  get() {
    return Repository.get<Team[]>(`${teams}`);
  },
  getQuery() {
    return useQuery({
      queryKey: [TeamsQueryKeys.TEAMS],
      queryFn: this.get,
    });
  },
  getTeamTypes() {
    return Repository.get<TeamType[]>(`${teamTypes}`);
  },
  getTeamDetails(teamId: string) {
    return Repository.get<TeamDetails>(`${teams}/${teamId}`);
  },
  updateTeamDetails(teamId: string, team: Team) {
    return Repository.patch<TeamDetails>(`${teams}/${teamId}`, team);
  },
  createTeam(team: Team) {
    return Repository.post(`${teams}`, team);
  },
  deleteTeam(id: string) {
    return Repository.delete(`${teams}/${id}`);
  },
  updateTeamMembers(teamId: string, team: TeamMembers) {
    return Repository.post<TeamDetails>(`${teams}/${teamId}/member`, team);
  },
};

export enum TeamsQueryKeys {
  TEAMS = "teams",
}
